import ModalWrapper from '@Components/Modals/ModalWrapper/ModalWrapper';
import ReportService from '@Services/Report.services.ts';
import { KGPortalUser } from '@Types/User.type';
import { OFFBOARDING_PDF_FILE_NAME } from '@Utils/constants';
import { downloadDocument } from '@Utils/document.utils.ts';
import { handleRequestError } from '@Utils/request.utils';
import { ErrorDisplay, Toast } from '@kg-internal/pv3-uikit';
import { useState } from 'react';

type Props = {
  show: boolean;
  onSuccess: () => void;
  onClose: () => void;
  user?: KGPortalUser;
};
const OffboardingPDFModal = ({ show, onSuccess, onClose, user }: Props) => {
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
  const handleGenerateOffboardingPDF = () => {
    const data = {
      user,
      reportType: 'Offboarding',
      timezone: new Date().getTimezoneOffset(),
      filter: {},
      filename: OFFBOARDING_PDF_FILE_NAME,
    };
    ReportService.createReport(data)
      .then((response) => {
        const report = response.data;
        if (report.generatedDocument.url !== '') {
          downloadDocument(report.generatedDocument.url);
        }
        Toast.success('PDF generated successfully.');
        onSuccess();
        onClose();
      })
      .catch((error) => handleRequestError(error, setErrorMessage, true));
  };
  return (
    <div className='modal--fit-content modal--w-30vw modal--pt-25vh'>
      <ModalWrapper
        show={show}
        title='Generate Offboarding PDF'
        handleClose={onClose}
        primaryButtonText='Confirm'
        primaryAction={handleGenerateOffboardingPDF}>
        {errorMessage ? (
          <ErrorDisplay inline details={errorMessage} />
        ) : (
          <div className='grid'>
            <div className='col-12'>
              <h3>Offboarding PDF</h3>
              <p>This will generate an offboarding PDF for the user. Please confirm to proceed.</p>
            </div>
          </div>
        )}
      </ModalWrapper>
    </div>
  );
};

export default OffboardingPDFModal;
